export const typeSafeObjectFromEntries = <
  Key extends string | number | symbol,
  Value,
>(
  entries: [Key, Value][]
): Record<Key, Value> => {
  const object: Record<Key, Value> = {} as Record<Key, Value>;
  for (const [key, value] of entries) {
    object[key] = value;
  }
  return object;
};
